import React, { useState } from "react";
import useApi from "../../../CustomHooks/useApi";

const ChangeParentModal = ({
    user,
    onClose,
    onSelectParent,
    onConfirm,
    mappingResult,
    showResultOnly,
    loading,
}) => {
    const [mobile, setMobile] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedParent, setSelectedParent] = useState(null);

    const { callApi: searchUsers } = useApi(
        "/admin/users/search/map-users/new/v1/not-of-type",
        "GET"
    );

    /* ===== SEARCH HANDLER ===== */
    const handleSearch = async () => {
        if (!mobile) return;

        const params = new URLSearchParams();
        params.append("mobile", mobile);

        try {
            const res = await searchUsers(null, `?${params.toString()}`);
            const list = Array.isArray(res?.content)
                ? res.content
                : Array.isArray(res)
                    ? res
                    : [];

            setSearchResults(list);
        } catch (err) {
            console.error("Parent search failed", err);
            setSearchResults([]);
        }
    };

    const handleSelectParent = (parent) => {
        setSelectedParent(parent);
        onSelectParent(parent);
    };

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white w-[420px] rounded-xl p-5">

                <h3 className="text-lg font-semibold mb-3">
                    Change Children Mapping
                </h3>

                {/* ================= RESULT MODE ================= */}
                {showResultOnly ? (
                    <>
                        <div
                            className={`border rounded-lg p-4 text-sm space-y-2 ${mappingResult?.status === "SUCCESS"
                                ? "border-green-300 bg-green-50 text-green-800"
                                : "border-red-300 bg-red-50 text-red-800"
                                }`}
                        >
                            <div className="font-semibold">
                                {mappingResult?.message}
                            </div>
                            <div className="font-semibold">
                                {mappingResult?.parentUserId}
                            </div>
                            <div className="font-semibold">
                                {mappingResult?.parentRole}
                            </div>
                            <div className="font-semibold">
                                {mappingResult?.parentMobile}
                            </div>
                              <div className="font-semibold">
                                {mappingResult?.parentName}
                            </div>

                            {mappingResult?.mappedUsers?.map((u) => (
                                <div
                                    key={u.userId}
                                    className="border-t pt-2 text-xs"
                                >
                                    <div>
                                        <b>User:</b> {u.name} ({u.role})
                                    </div>
                                    <div
                                        className="font-medium text-green-600"
                                    >
                                        {u.status}
                                    </div>
                                    <div className="font-medium text-green-600">
                                        {u.message}
                                    </div>
                                    <div className="font-medium text-green-600">
                                        {u.userId}
                                    </div>
                                    <div className="font-medium text-green-600">
                                        {u.role}
                                    </div>
                                    <div className="font-medium text-green-600">
                                        {u.mobile}
                                    </div>
                                      <div className="font-medium text-green-600">
                                        {u.name}
                                    </div>

                                </div>
                            ))}
                        </div>

                        <div className="flex justify-end mt-5">
                            <button
                                onClick={onClose}
                                className="px-5 py-2 bg-indigo-600 text-white rounded"
                            >
                                OK
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        {/* ================= FORM MODE ================= */}

                        <div className="text-sm mb-3">
                            <b>Child:</b> {user.username} ({user.role})
                        </div>


                        {/* ===== SEARCH INPUT ===== */}
                        <div className="flex gap-2 mb-3">
                            <input
                                type="text"
                                placeholder="Search parent by mobile"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                className="flex-1 border rounded px-3 py-2 text-sm"
                            />

                            <button
                                onClick={handleSearch}
                                className="px-4 py-2 bg-indigo-600 text-white rounded text-sm"
                            >
                                Search
                            </button>
                        </div>

                        {/* ===== SEARCH RESULTS ===== */}
                        {searchResults.length > 0 && (
                            <div className="border rounded-md max-h-48 overflow-y-auto mb-4">
                                {searchResults.map((u) => (
                                    <div
                                        key={u.userId}
                                        onClick={() => handleSelectParent(u)}
                                        className={`px-3 py-2 text-sm cursor-pointer hover:bg-slate-100
                                    ${selectedParent?.userId === u.userId
                                                ? "bg-indigo-50"
                                                : ""
                                            }`}
                                    >
                                        <div className="font-medium">
                                            {u.mobile} || {u.userId}
                                        </div>
                                        <div className="text-xs text-slate-500">
                                            {u.role}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className="flex justify-end gap-3 mt-4">
                            <button
                                onClick={onClose}
                                className="px-4 py-2 border rounded"
                            >
                                Cancel
                            </button>

                            <button
                                disabled={!selectedParent || loading}
                                onClick={onConfirm}
                                className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
                            >
                                {loading ? "Mapping..." : "Confirm"}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>

    );
};

export default ChangeParentModal;
